import { ITenantBids } from 'app/shared/model/tenant-bids.model';
import { PaymentStatus } from 'app/shared/model/enumerations/payment-status.model';

export interface ITenantBidPayment {
  id?: string;
  paymentMethod?: string | null;
  transactionDetails?: string | null;
  paidAmount?: number | null;
  active?: boolean | null;
  tmCursor?: number | null;
  timestampEntry?: number | null;
  microSec?: number | null;
  lastUpdated?: number | null;
  paymentStatus?: keyof typeof PaymentStatus | null;
  voided?: boolean | null;
  voidedReason?: string | null;
  voidedDate?: number | null;
  tenantBid?: ITenantBids | null;
}

export const defaultValue: Readonly<ITenantBidPayment> = {
  active: false,
  voided: false,
};
